<template>
  <div class="c-team-popin u-fixed u-pos-tl u-viewport-fit-h u-fit-w u-vacuum" style="z-index:10000000;">
     <div class="c-team-popin__content u-absolute u-pos-tl u-fit-w">
        <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-tl u-fit-w u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-bl u-fit-w u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark"></div>
     </div>
     <div class="c-team-popin__content o-wrapper--panel u-fit">
        <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-tl u-fit-w u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-br u-fit-w u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark"></div>
        <div class="o-wrapper--panel  u-fit u-overflow-h">
           <div class="u-relative u-zindex--1 u-inline-block u-valign-top u-fit-h u-w1of2 u-cover u-hide@sm" v-if="content!=null">
              <div class="u-absolute u-pos-tl u-zindex--1 u-fit u-cover"  >
    <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
        <swiper-slide  v-for="(post,indexkey)  in content.images"  v-if="indexkey>0" :key="indexkey" :style="{'background-image':'url('+post.sizes.medium+'?'+getRandomNumber(200,2000)+')' }">

        </swiper-slide>

        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper :options="swiperOptionThumbs"  class="gallery-thumbs" ref="swiperThumbs">
        <swiper-slide  v-for="(post,indexkey)  in content.images"  v-if="indexkey>0" :style="{'background-image':'url('+post.sizes.medium+'?'+getRandomNumber(200,2000)+')' }"  :key="indexkey">

        </swiper-slide>

      </swiper>
              </div>
           </div>
           <div class="o-wrapper--valign u-inline-block u-valign-top u-fit-h  u-pad-x-w1of12  u-pad-l-w1of16@xl u-pad-r-w1of16@xl u-pad-l-0@sm u-pad-r-0@sm u-bg--white u-w1of2 u-w2of2@sm " style="background-color:#f7f7f7;" v-if="content!=null">
              <div class="u-flex u-flex-ai--center  u-flex-ai--start@sm u-fit">
                <div class="c-team-popin__container__content   toscrollup u-force-3d u-pad-y-xl@sm u-marg-t-md u-marg-t-xs@sm">
                   <h5 class="c-team-popin__container__content__name c-team-popin__line u-pad-x-w1of8@sm t-text--roman u-color--gray  u-marg-b-md  u-marg-t-xs" v-html="content.title"></h5>
                   <h6 class="c-team-popin__line u-pad-x-w1of8@sm t-h5 t-text--title-NavalVessels-AquaBold u-color--gray u-marg-b-xs">{{content.ItemListspecsTitleA}}</h6>
                   <div v-for="(itemList, indexlist)  in content.ItemListspecsA" :key="indexlist" class="c-team-popin__line o-content u-pad-x-w1of8@sm t-text--md u-color--gray u-marg-b-xs u-marg-r-sm"  v-html="itemList.label"></div>
                   <h6 class="c-team-popin__line u-pad-x-w1of8@sm t-h5 t-text--title-NavalVessels-AquaBold u-pad-t-md u-color--gray u-marg-b-xs ">{{content.ItemListspecsTitleB}}</h6>
                     <div v-for="(itemList, indexlist)  in content.ItemListspecsB" :key="indexlist" class="c-team-popin__line o-content u-pad-x-w1of8@sm t-text--md u-color--gray  u-marg-r-sm"  v-html="itemList.label"></div>
                     <div class="c-team-popin__line o-content u-w2of2@sm u-w1of2 u-pad-t-md u-pad-x-w1of8@sm t-text--md u-color--gray u-marg-b-sm u-marg-r-sm"  v-html="content.first_paragraph_shorted"></div>
                </div>
              </div>
           </div>
           <div class="c-team-popin__aside o-wrapper--valign u-absolute u-zindex--2 u-align-right u-bg--brand-dark u-hide@sm">
              <div class="c-team-popin__aside__content u-inline-block u-valign-middle u-marg-r-lg">
                 <div class="u-inline-block u-valign-middle">
                   <span class="t-text--xs u-inline-block u-valign-middle u-color--alpha-white u-marg-r-sm">{{title}}</span>
                    <span class="c-line c-line--x u-inline-block u-valign-middle u-bg--white u-marg-r-sm" style="width: 45px;"></span>
                     <span class="t-text--xs u-inline-block u-valign-middle u-color--alpha-white">{{"00" + (index + 1)}}</span>
                   </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'


//import { Carousel, Slide } from 'vue-carousel'
import { swiper, swiperSlide } from 'vue-awesome-swiper'


export default {
  name: "app-car-details",
               props: {
                 debug: {
                   type: Boolean,
                   default: !1
               },
                   content: {
                       type: Object,
                       default: function() {}
                   },
                   isActive: {
                       type: Boolean,
                       default: !1
                   },
                   title: {
                       type: String,
                       default: ""
                   },
                   index: {
                       type: Number,
                       default: 0
                   }
               },
               data: function() {
                   return {
                       buttonHoveredIndex: null,
                       vCardLink: "",
                      /* swiperOption: {
                                                 direction: 'vertical',
                                                 slidesPerView: 1,
                                                 spaceBetween: 30,
                                                 mousewheel: true,
                                                 pagination: {
                                                   el: '.swiper-pagination',
                                                   clickable: true
                                                 }
                                    }*/
                                    swiperOptionTop:
                                    {
                                        spaceBetween: 10,
                                        navigation: {
                                          nextEl: '.swiper-button-next',
                                          prevEl: '.swiper-button-prev'
                                        }
                                    },
                                  swiperOptionThumbs: {
                                    spaceBetween: 10,
                                    centeredSlides: true,
                                    slidesPerView: 'auto',
                                    touchRatio: 0.2,
                                    slideToClickedSlide: true
                                  }
                            }
                   }
               ,
               components: {


                    //Carousel,
                  //Slide,
                    swiper,
                    swiperSlide
               },

               watch: {
                   isActive: "onActiveChange"
               },
               created: function()
               {
                   this.onPrintPage = this.onPrintPage.bind(this),
                   this.eventHub.$on("print:page", this.onPrintPage)
               },
               mounted: function() {

                 this.$nextTick(() => {
                              //console.log(this.swiper);
                              //const swiperThumbs = this.$refs.swiperThumbs.swiper
                              this.swiper.controller.control = this.swiperthumb
                              this.swiperthumb.controller.control = this.swiper
                            })

               },
               computed:
               {
                 swiper()
                 {
                   return this.$refs.swiperTop.swiper
                 },
                 swiperthumb()
                 {
                   return this.$refs.swiperThumbs.swiper
                 }
               },
               destroyed: function() {
                   this.eventHub.$off("print:page", this.onPrintPage)
               },
               methods: {
                 getRandomNumber: function(min, max) {
                      return Math.floor(Math.random() * (max -min +1)) + min;
                      },
                   onActiveChange: function()
                   {

                       this.$el.querySelector(".toscrollup").scrollTop=0,

                       this.$buttons = this.$el.querySelectorAll(".js-button-hovered"),
                       this.isActive
                       ?
                       (document.addEventListener("keydown", this._onKeydown), this.$el.classList.add("is-visible"))
                       :
                       (document.removeEventListener("keydown", this._onKeydown),  this.$el.classList.remove("is-visible"))
                   },
                   _onKeydown: function(t) {
                       27 === t.keyCode && this.eventHub.$emit("close:popin")
                   },
                   toDataURL: function(t, e)
                   {
                       var n = new XMLHttpRequest;
                       n.onload = function()
                       {
                           var t = new FileReader;
                           t.onloadend = function() {
                               e(t.result)
                           }, t.readAsDataURL(n.response)
                       }, n.open("GET", t), n.responseType = "blob", n.send()
                   },
                   onPrintPage: function() {
                       window.print()
                   },
                   _onMouseenterButton: function(t)
                   {
                       0 === t && (this.$buttons[1].style.transform = "translateX(" + (this.$buttons[t].offsetWidth - 1) + "px) translateY(0) translateZ(0)")
                   },
                   _onMouseleaveButton: function(t)
                   {
                       0 === t && (this.$buttons[1].style.transform = "translateX(0) translateY(0) translateZ(0)")
                   }
               }
}
</script>
<style scoped>
/*
.swiper-box {
   width: 100%;
   height: 100%;
   margin: 0 auto;
 }
 .swiper-item {
   height: 100%;
   text-align: center;
   font-size: 18px ;
   background: #fff;

   display: -webkit-box;
   display: -ms-flexbox;
   display: -webkit-flex;
   display: flex;
   -webkit-box-pack: center;
   -ms-flex-pack: center;
   -webkit-justify-content: center;
   justify-content: center;
   -webkit-box-align: center;
   -ms-flex-align: center;
   -webkit-align-items: center;
   align-items: center;
 }
*/
  .swiper-container {
   background-color: #ececec;
 }
 .swiper-slide {
   background-size: cover;
   background-position: center;
 }
 .gallery-top {
   height: 80%!important;
   width: 100%;
 }
 .gallery-thumbs {
   height: 20%!important;
   box-sizing: border-box;
   padding: 10px 0;
 }
 .gallery-thumbs .swiper-slide {
   width: 25%;
   height: 100%;
   opacity: 0.4;
 }
 .gallery-thumbs .swiper-slide-active {
   opacity: 1;
 }
</style>
